<template>
  <div
    class="price"
    itemprop="offers"
    itemscope
    itemtype="http://schema.org/Offer"
    v-if="jewel.price"
  >
    <meta content="Брест" itemprop="eligibleRegion">
    <p>
      <span itemprop="price">{{ jewel.price | priceFormat }}</span>
      <span itemprop="priceCurrency" content="BYN">р</span>.
    </p>
  </div>
</template>

<script>
export default {
  name: 'CatalogJewelArticleDescriptionPrice',
  props: ['jewel'],
  data: function () {
    return {}
  },
  filters: {
    priceFormat (value) {
      return value.toFixed(2)
    }
  }
}
</script>

<style scoped lang="scss">
  .price {
    color: $default-link-color;
    font-family: "Gotham Pro Regular", $font-stack;
    font-size: 2em;
    font-weight: bold;
    margin-bottom: 1em;
    & > p {
      margin-bottom: 0;
      line-height: normal;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/the-content/catalog-jewel-article/catalog-jewel-article-description/CatalogJewelArticleDescriptionPrice.vue